import axios from 'axios';

const apiBase = (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.startsWith('http'))
  ? process.env.REACT_APP_API_URL
  : '/api';

const TRAINING_BASE = `${apiBase}/training`;

const trainingApi = axios.create({
  baseURL: TRAINING_BASE,
  timeout: 30000,
});

trainingApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('trainingToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

trainingApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('trainingToken');
      localStorage.removeItem('trainingUser');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login?portal=szkolenia';
      }
    }
    return Promise.reject(error);
  }
);

export const trainingAuth = {
  login: async (username, password) => {
    const res = await trainingApi.post('/auth/login', { username, password }, { timeout: 30000 });
    if (res.data && res.data.token) {
      localStorage.setItem('trainingToken', res.data.token);
      localStorage.setItem('trainingUser', JSON.stringify(res.data.user || {}));
    }
    return res.data;
  },
  logout: () => {
    localStorage.removeItem('trainingToken');
    localStorage.removeItem('trainingUser');
  },
  getToken: () => localStorage.getItem('trainingToken'),
  getUser: () => {
    const s = localStorage.getItem('trainingUser');
    return s ? JSON.parse(s) : null;
  },
};

// Bezpośredni URL do strumienia wideo (z tokenem w query, bo <video> nie wysyła nagłówka Authorization)
export const trainingVideoUrl = (trainingId) => {
  const token = localStorage.getItem('trainingToken');
  return `${TRAINING_BASE}/trainings/${trainingId}/video?token=${encodeURIComponent(token || '')}`;
};

export default trainingApi;
